import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '../utils/cn';

const eyebrowVariants = cva(
  'inline-flex items-center gap-2 font-mono text-[12px] tracking-wide leading-none',
  {
    variants: {
      variant: {
        plain: 'text-ink-500 uppercase tracking-wider font-medium',
        pill:
          'px-3.5 py-1.5 bg-white border border-ink-200 rounded-full text-ink-700 shadow-card',
        'pill-saffron':
          'px-3.5 py-1.5 bg-saffron-50 border border-saffron-200 rounded-full text-saffron-700',
        'pill-violet':
          'px-3.5 py-1.5 bg-violet-50 border border-violet-200 rounded-full text-violet-700',
      },
    },
    defaultVariants: { variant: 'plain' },
  }
);

export interface EyebrowProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof eyebrowVariants> {
  dot?: boolean;
}

export const Eyebrow = forwardRef<HTMLSpanElement, EyebrowProps>(
  ({ className, variant, dot, children, ...props }, ref) => (
    <span ref={ref} className={cn(eyebrowVariants({ variant }), className)} {...props}>
      {dot && (
        <span className="w-1.5 h-1.5 rounded-full bg-saffron-500 shadow-[0_0_8px_rgba(255,107,26,0.5)]" />
      )}
      {children}
    </span>
  )
);
Eyebrow.displayName = 'Eyebrow';
